import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiMethod } from 'src/app/decorators/api-method.decorator';
import { AuthPage } from 'src/app/models/auth/auth-page.model';
import { PreferredUserAccessInfo } from 'src/app/models/auth/preferred-user-access-info.model';
import { JobBriefInfo } from 'src/app/models/my-work/job-brief-info.model';
import { JobLogbook } from 'src/app/models/my-work/job-logbook.model';
import { MyWorkJob } from 'src/app/models/my-work/my-work-job.model';
import { UserAccountInfo } from 'src/app/models/user-account-info.model';
import { environment } from 'src/environments/environment';
import { AuthService } from '../../auth.service';
import { AccountRouteService } from '../../interfaces/account-route-service.abstract';

@Injectable({
	providedIn: 'root'
})
export class MyWorkService extends AccountRouteService {

	private baseMyWorkUrl = `${environment.baseUrl}/mywork`;
	private baseUserUrl = `${environment.baseUrl}/user`;

	constructor(
		private httpClient: HttpClient,
		private authService: AuthService
	) {
		super();
	}

	@ApiMethod()
	getMyWorkJobs(token: string, showAllShifts: boolean = false): Observable<MyWorkJob[]> {
		return this.httpClient.get<MyWorkJob[]>(`${this.baseMyWorkUrl}/${token}/scheduled`, {
			params: {
				showAllShifts: showAllShifts.toString()
			}
		});
	}

	@ApiMethod()
	getBriefMyWorkJobs(token: string): Observable<JobBriefInfo[]> {
		return this.httpClient.get<JobBriefInfo[]>(`${this.baseMyWorkUrl}/${token}/brief`);
	}

	@ApiMethod()
	getMyWorkJobLogbook(token: string): Observable<JobLogbook[]> {
		return this.httpClient.get<JobLogbook[]>(`${this.baseMyWorkUrl}/${token}/logbook`);
	}

	@ApiMethod()
	getMyWorkSmartDocs(token: string): Observable<MyWorkJob[]> {
		return this.httpClient.get<MyWorkJob[]>(`${this.baseMyWorkUrl}/${token}/smart-docs`);
	}

	@ApiMethod()
	getRedirectUri(token: string): Observable<{ smartSyncUri: string }> {
		return this.httpClient.get<{ smartSyncUri: string }>(`${this.baseMyWorkUrl}/${token}/url`);
	}

	@ApiMethod()
	getMyWorkRedirectUriById(userAccountId: number): Observable<{ smartSyncUri: string }> {
		return this.httpClient.get<{ smartSyncUri: string }>(`${this.baseMyWorkUrl}/${userAccountId}/id-url`, { headers: this.authService.getAuthenticationHeader() });
	}

	@ApiMethod()
	isVendor(token: string): Observable<boolean> {
		return this.httpClient.get<boolean>(`${this.baseUserUrl}/${token}/is-vendor`);
	}

	@ApiMethod()
	hasJobShifts(token: string): Observable<boolean> {
		return this.httpClient.get<boolean>(`${this.baseUserUrl}/${token}/has-job-shifts`);
	}

	@ApiMethod()
	isUserAccountAllowedAccess(token: string): Observable<PreferredUserAccessInfo> {
		return this.httpClient.get<PreferredUserAccessInfo>(`${this.baseMyWorkUrl}/${token}/is-authorized`, { headers: this.authService.getAuthenticationHeader() });
	}

	@ApiMethod()
	getUserAccountInfo(token: string): Observable<UserAccountInfo> {
		return this.httpClient.get<any>(`${this.baseMyWorkUrl}/${token}/user-info`);
	}
}



